// profanityFilter.ts
// Simple profanity filter with normalization and allowlist

// Blocklist - expand as needed
const BLOCKLIST = [
  'DAMN',
  'HELL',
  'SHIT',
  'FUCK',
  'COCK',
  'DICK',
  'CUNT',
  'BITCH',
  'PUSSY',
  'BASTARD',
  'ASS',
  'PISS',
  'TITS',
  'SLUT',
  'WHORE',
  'FAG',
  'DYKE',
  'RETARD',
  'NIGGER',
  'NIGGA',
  'KIKE',
  'SPIC',
  'CHINK'
];

// Allowlist - valid words that might trigger false positives
const ALLOWLIST = [
  'BASS',      // contains ASS
  'PASS',      // contains ASS
  'LASS',      // contains ASS
  'MASS',      // contains ASS
  'CLASS',     // contains ASS
  'GLASS',     // contains ASS
  'GRASS',     // contains ASS
  'ASSESS',    // contains ASS
  'ASSENT',    // contains ASS
  'ASSIST',    // contains ASS
  'DICKENS',   // contains DICK
  'COCOON',    // contains COO
  'PEACOCK',   // contains COCK
  'TITMOUSE',  // contains TIT
  'TITANIC',   // contains TIT
  'PUSILLANIMOUS', // contains PUS
  'SCUNTHORPE',    // contains... well
  'SHITAKE',    // mushroom variant spelling
  'SHELL',
  'SHELLS',
  'SHELLED',
  'REASSURE',
  'REASSURES',
  'REASSURED',
  'ASSURES',
  'ASSURE',
  'ASSURED',
  'ASSUAGE',
  'ASSUAGES',
  'HASSLE',
  'HASSLED',
  'HASSLES',
  'TASSEL',
  'ASSASSINATE',
  'ASSASSINATION',
  'ASSASSINATES',
  'ASSASSINATED',
  'ASSASSINATING',
  'ASSASSINATIONS',
  'TITULAR',
  'ASSASSIN',
  'ASSASSINS',
  'SASS',
  'SASSY',
  'BYPASS',
  'PASS',
  'BYPASSES',
  'PASSES',
  'BYPASSED',
  'PASSWORD',
  'PASSWORDS',

  // ---- APPENDED (STRICT MATCHES ONLY) ----

  // ASS
  'ASSEMBLE',
  'ASSEMBLES',
  'ASSEMBLED',
  'ASSEMBLY',
  'ASSIGN',
  'ASSIGNS',
  'ASSIGNED',
  'ASSIGNMENT',
  'ASSOCIATE',
  'ASSOCIATES',
  'ASSOCIATED',
  'ASSOCIATION',
  'ASSOCIATIONS',
  'ASSURANCE',
  'ASSURANCES',
  'COMPASS',
  'COMPASSES',
  'COMPASSION',
  'EMBARRASS',
  'EMBARRASSES',
  'EMBARRASSED',
  'EMBARRASSING',
  'PASSAGE',
  'PASSAGES',
  'PASSENGER',
  'PASSENGERS',
  'CLASSIC',
  'CLASSICS',
  'CLASSIFY',
  'CLASSIFIED',
  'CLASSIFIEDS',
  'CLASSROOM',
  'CLASSROOMS',

  // HELL
  'SHELLFISH',
  'EGGSHELL',
  'EGGSHELLS',
  'SEASHELL',
  'SEASHELLS',
  'BOMBSHELL',
  'BOMBSHELLS',
  'BOOKSHELF',
  'MICHELL',        // proper noun
  'SCHELLING',      // economist surname
  'HELLENIC',
  'HELLENISM',

  // SHIT
  'SHITTIM',        // biblical acacia tree
  'SHITTIMWOOD',

  // COCK
  'COCKPIT',
  'COCKPITS',
  'COCKATOO',
  'COCKATOOS',
  'WOODCOCK',
  'WOODCOCKS',
  'WEATHERCOCK',
  'WEATHERCOCKS',
  'COCKTAIL',
  'COCKTAIL',

  // DICK
  'DICKINSON',
  'DICKINSONS',
  'DICKENSIAN',

  // PUSSY
  'PUSSYCAT',
  'PUSSYCATS',
  'PUSSYWILLOW',
  'PUSSYWILLOWS',

  // DAMN
  'DAMNATION',
  'DAMNATIONS',
  'DAMNABLE',

  // RETARD
  'RETARDANT',
  'RETARDANTS',

  // FAG
  'FAGOT',
  'FAGOTTO',

  // BASTARD
  'BASTARDIZE',
  'BASTARDIZED',
  'BASTARDIZATION',

  // PISS
  'PISSARRO',       // painter (proper noun)

  // SLUT
  'ABSOLUT',        // brand name; exact substring SLUT
  'SLUTSKY'         // economist surname

];

/**
 * Normalize word for profanity checking
 * - Convert to uppercase
 * - Remove non-letters
 * - Replace leetspeak with letters
 */
function normalizeWord(word: string): string {
  return word
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '') // Remove non-alphanumeric
    .replace(/0/g, 'O')
    .replace(/1/g, 'I')
    .replace(/3/g, 'E')
    .replace(/4/g, 'A')
    .replace(/5/g, 'S')
    .replace(/7/g, 'T');
}

/**
 * Check if a word is profane
 * Returns true if word should be blocked
 */
export function isProfane(word: string): boolean {
  const normalized = normalizeWord(word);
  
  // Check allowlist first (whitelist takes precedence)
  if (ALLOWLIST.includes(normalized)) {
    return false;
  }
  
  // Check if word exactly matches blocklist
  if (BLOCKLIST.includes(normalized)) {
    return true;
  }
  
  // Check if word contains any blocklisted substring
  for (const profanity of BLOCKLIST) {
    if (normalized.includes(profanity)) {
      return true;
    }
  }
  
  return false;
}
